<template>
  <div class="page-home">
    <!--banner-->
    <div class="banner">
      <div class="container">
        <h2>游戏推荐</h2>
        <div class="banner-matter">
          <Slider/>
        </div>
      </div>
    </div>
    <!--banner end-->
    <!--content-->
    <div class="content" style="display: block;">
      <div class="container">
        <!--content-top-->
        <div class="content-top">
          <div class="col-md-9 top-col">
            <!--Left-->
            <div class="col-top">
              <div class="col-md-6 black" v-for="n in navLeftList">
                <a :href="'static/article/'+n.path+'.html'" target="_blank" v-if="n.html">
                  <img class="img-responsive" :src="'static/images/index/'+n.path+'.jpg'" alt="">
                  <div class="col">
                    <h4>{{ n.title }}</h4>
                  </div>
                </a>
                <router-link :to="'/game/'+n.path" :title="n.title" target="_blank" v-if="!n.html">
                  <img class="img-responsive" :src="'static/images/index/'+n.path+'.jpg'" alt="">
                  <div class="col">
                    <h4>{{ n.title }}</h4>
                  </div>
                </router-link>
              </div>

              <div class="clearfix"></div>
            </div>
            <!--Text AD-->
            <div class="col-top-bottom">
              <div class="ad-block">
                <AdIndex/>
              </div>

              <div class="clearfix"></div>
            </div>
          </div>
          <!--Right-->
          <div class="col-md-3 per">
            <a
:href="'static/article/'+r.path+'.html'"
v-for="r in navRightList"
:title="r.title"
target="_blank"
               v-if="r.html">
<!--              <img class="img-responsive" :src="'static/images/index/'+r.path+'.jpg'" alt="">-->
              <el-image class="img-responsive" :src="'static/images/index/'+r.path+'.jpg'" alt="">
                <div slot="placeholder" class="img-placeholder home">
                  图片加载中<span class="dot">...</span>
                </div>
              </el-image>
              <div class="six">
                <h4>{{ r.title }}</h4>
              </div>
            </a>
            <router-link
:to="'/game/'+r.path"
v-for="r in navRightList"
:title="r.title"
target="_blank"
                         v-if="!r.html">
              <el-image class="img-responsive" :src="'static/images/index/'+r.path+'.jpg'" alt="">
                <div slot="placeholder" class="img-placeholder home">
                  图片加载中<span class="dot">...</span>
                </div>
              </el-image>
<!--              <img class="img-responsive" :src="'static/images/index/'+r.path+'.jpg'" alt="">-->
              <div class="six">
                <h4>{{ r.title }}</h4>
              </div>
            </router-link>

          </div>

          <div class="clearfix"></div>
        </div>
      </div>
      <!--//content-top-->
      <!---->
      <div class="container">
        <div class="content-bottom">
          <!-- 最近发布 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>最近发布
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
                class="col-md-3 blog-top"
                v-for="(game,index) in gameListNew"
                v-if="index < showNumber"
                :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 最近更新 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>最近版本更新
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in gameListRecent"
v-if="index < showNumber"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 已汉化 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>已汉化的游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in gameList"
v-if="index < showNumber"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank" v-if="!game.flash">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- 汉化中 -->
          <div class="col-md-12 bottom-content no-plr">
            <h4>汉化中的游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in gameList2"
v-if="index < showNumber"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank" v-if="!game.flash">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="clearfix"></div>
          <!--  其它游戏-->
          <div class="col-md-12 bottom-content no-plr">
            <h4>其它游戏
              <router-link to="/game">查看更多 ></router-link>
            </h4>
            <div
class="col-md-3 blog-top"
v-for="(game,index) in gameList3"
v-if="index < showNumberOther"
                 :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank" v-if="!game.flash">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
              <a :href="'static/flash/'+game.path+'.html'" :title="game.title" target="_blank" v-if="game.flash">
                <div class="blog-in">
                  <div class="face-box" :style="'background: url(static/images/game/'+game.path+'/jietu-1.png) no-repeat;'" :title="game.title">
<!--                    <img class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">-->
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div>（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>

    </div>
    <!--content-->
  </div>
</template>

<script>
import AdIndex from '@/components/Home/Ad_Top.vue'
import Slider from '@/components/Home/Slider.vue'

export default {
  name: 'Index',
  components: {
    AdIndex,
    Slider
  },
  data() {
    return {
      showNumber: 8,
      showNumberOther: 12,
      typeList: [],
      navLeftList: [],
      navRightList: [],
      gameList: [],
      gameList2: [],
      gameList3: [],
      gameListRecent: [],
      gameListNew: [],
      curType: '已汉化',
      curType2: '汉化中',
      count: 20
    }
  },
  created() {
    this.getData()
    this.getNavData()
  },
  mounted() {
  },
  beforeDestroy() {
    this.typeList = []
    this.navLeftList = []
    this.navRightList = []
    this.gameList = []
    this.gameList2 = []
    this.gameList3 = []
    this.gameListRecent = []
    this.gameListNew = []
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        for (var i = 0; i < game.data.length; i++) {
          if (game.data[i].status !== 0) {
            game.data[i].type.forEach(item => {
              if (item === this.curType) {
                // 已汉化
                this.gameList.push(game.data[i])
              } else if (item === this.curType2) {
                // 汉化中
                this.gameList2.push(game.data[i])
              }
            })
          }
        }
        // 其它游戏
        for (var c = 0; c < game.data.length; c++) {
          if (game.data[c].status !== 0) {
            if ((game.data[c].type.indexOf(this.curType) === -1) && (game.data[c].type.indexOf(this.curType2) === -1)) {
              this.gameList3.push(game.data[c])
            }
          }
        }
        // 最近更新
        var rows = game.data
        // 转换日期格式为时间戳
        for (var r = 0, l = rows.length; r < l; r++) {
          var a = rows[r].update
          var b = rows[r].date
          if (a && rows[r].status !== 0) {
            var date1 = Date.parse(new Date(a))
            rows[r].update = date1
            this.gameListRecent.push(rows[r])
          }
          if (b && rows[r].status !== 0) {
            var date2 = Date.parse(new Date(b))
            rows[r].date = date2
            this.gameListNew.push(rows[r])
          }
        }
        // 最近更新排序
        this.gameListRecent.sort(this.compare('update'))
        // 最近发布排序
        this.gameListNew.sort(this.compare('date'))
        // 排序完，还原日期格式
        this.gameListRecent.forEach(el => {
          const date = new Date(el.update)
          const year = date.getFullYear()
          const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
          const day = date.getDate() > 9 ? date.getDate() : '0' + (date.getDate())
          el.update = year + '-' + month + '-' + day
        })
        // 排序-最近发布
        this.gameListNew.forEach(el => {
          const date = new Date(el.date)
          const year = date.getFullYear()
          const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
          const day = date.getDate() > 9 ? date.getDate() : '0' + (date.getDate())
          el.date = year + '-' + month + '-' + day
        })
        this.gameListRecent.reverse()
        this.gameListNew.reverse()
        // console.log(this.gameListNew)
      })
    },
    compare(prop) {
      return function(obj1, obj2) {
        var val1 = obj1[prop]
        var val2 = obj2[prop]
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
    },
    getNavData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/home_nav_ad.json' + '?' + timeStamp).then(game => {
        // 左侧数据
        for (var i = 0; i < game.data[0].left.length; i++) {
          if (game.data[0].left[i].status === 1) {
            this.navLeftList.push(game.data[0].left[i])
          }
        }
        // 右侧数据
        for (var j = 0; j < game.data[1].right.length; j++) {
          if (game.data[1].right[j].status === 1) {
            this.navRightList.push(game.data[1].right[j])
          }
        }
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue